<template>
  
    
        <v-container>
            <v-app-bar scroll-behavior="elevate">
                <template v-slot:prepend>
                    <v-app-bar-title class="font-weight-black">
                        <img src='/w_icon_medium.png' class="icon-logo" style="cursor:pointer" @click="$router.push('/dashboard')">
                    </v-app-bar-title>
                </template>
                <v-spacer></v-spacer>
                <v-btn icon @click="$router.push('/notifications')" class="mr-2">
                    <v-badge :content="unreadCount" :model-value="unreadCount > 0" color="red" overlap>
                        <v-icon>mdi-bell-outline</v-icon>
                    </v-badge>
                </v-btn>
                <v-menu>
                    <template v-slot:activator="{ props }">
                        <v-btn v-bind="props" icon>
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item>
                            <v-list-item-title>
                                <a @click="logout" id="logoutLink">logout</a>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                
                
            </v-app-bar>
        </v-container>    
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
    data() {
        return {
            unreadCount: 0,
            pollInterval: null
        };
    },
    computed: {
        ...mapState({
            token: "token",
            notificationChange: "notificationChange"
        })
    },
    watch: {
        token(val) {
            if (val) {
                this.fetchUnreadCount();
            } else {
                this.unreadCount = 0;
            }
        },
        $route() {
            if (this.token) {
                this.fetchUnreadCount();
            }
        },
        notificationChange() {
            this.fetchUnreadCount();
        }
    },
    mounted() {
        if (this.token) {
            this.fetchUnreadCount();
            this.pollInterval = setInterval(() => this.fetchUnreadCount(), 60000);
        }
    },
    beforeUnmount() {
        if (this.pollInterval) clearInterval(this.pollInterval);
    },
    methods: {
        ...mapMutations(["setUser", "setToken", "destroyToken"]),
        ...mapGetters(["isLoggedIn"]),
        async fetchUnreadCount() {
            try {
                const response = await axios.get('/notifications/unread/count');
                this.unreadCount = response.data.count;
            } catch (error) {
                // silently fail — badge just won't update
            }
        },
        async logout(){
            const refreshToken = this.$store.state.refreshToken;
            if (refreshToken) {
                try { await axios.post('/auth/logout', { refresh_token: refreshToken }); }
                catch {}
            }
            this.destroyToken();
            localStorage.clear();
            this.$router.push('/');
        }
    }
};
</script>


<style scoped>

#logoutLink{
    font-family: 'Space Grotesk', 'Courier New', Courier, monospace, sans-serif;
    cursor: pointer;
}

.icon-logo{
    width: 35px;
    margin-left: 10px;
    margin-top: 7px;
}

.logo{
    margin-left: 10px;
    font-weight: 300;
}

</style>